import React, { useMemo } from "react";
import CapabilityCore from "./CapabilityCore";
import PathwayNode from "./PathwayNode";
import ResultantStrip from "./ResultantStrip";
import { groupPathways } from "./needsApplicationModel";

function PathwayColumn({ title, subtitle, groups, side, onInspect }) {
  return (
    <section className={`v25a-pathway-column ${side}`}>
      <div className="v25a-column-head">
        <span className="v25a-eyebrow">{title}</span>
        <small>{subtitle}</small>
      </div>

      <div className="v25a-pathway-stack">
        {groups.length ? (
          groups.map((group) => (
            <PathwayNode key={group.key} group={group} onInspect={onInspect} />
          ))
        ) : (
          <div className="v25a-empty-pathway">
            Ingen {side === "affording" ? "affording" : "constraining"} pathway
            er promotert i denne tilstanden.
          </div>
        )}
      </div>
    </section>
  );
}

export default function ConfigurationCanvas({
  capabilityLabel,
  state,
  pathways,
  onInspect,
}) {
  const groups = useMemo(() => groupPathways(pathways), [pathways]);
  const affording = groups.filter((g) => g.orientation === "affords");
  const constraining = groups.filter((g) => g.orientation === "constrains");
  const other = groups.filter(
    (g) => g.orientation !== "affords" && g.orientation !== "constrains"
  );

  return (
    <>
      <div className="v25a-configuration-canvas">
        <PathwayColumn
          title="AFFORDING PATHWAYS"
          subtitle="Gjør kapabiliteten mer mulig i denne konfigurasjonen"
          groups={affording}
          side="affording"
          onInspect={onInspect}
        />

        <div className="v25a-core-column">
          <CapabilityCore capabilityLabel={capabilityLabel} state={state} />
          <div className="v25a-center-caption">
            kapabiliteten forblir på samme sted
          </div>
        </div>

        <PathwayColumn
          title="CONSTRAINING PATHWAYS"
          subtitle="Begrenser kapabiliteten i denne konfigurasjonen"
          groups={constraining}
          side="constraining"
          onInspect={onInspect}
        />
      </div>

      {other.length ? (
        <div className="v25a-other-pathways">
          <span className="v25a-eyebrow">MIXED / UNRESOLVED</span>
          <div>
            {other.map((group) => (
              <PathwayNode key={group.key} group={group} onInspect={onInspect} />
            ))}
          </div>
        </div>
      ) : null}

      <ResultantStrip state={state} />
    </>
  );
}
